module.exports = __webpack_public_path__ + "img/infirmier-h.5c44d5fb.jpg";